import React from 'react';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { RADIUS } from '../../theme/muiTheme';
export default function LabeledField({
  label, htmlFor, required = false, error, helper, helperColor = 'text.secondary', children, sx,

}) {

  return (
    <FormControl
      fullWidth
      required={required}
      error={Boolean(error)}
      sx={{
        '& .MuiOutlinedInput-root': { borderRadius: `${RADIUS.control}px` },
        ...sx,
      }}
    >
      <FormLabel
        htmlFor={htmlFor}
        sx={{
          mb: 0.75,
          fontSize: 13,
          fontWeight: 600,
          lineHeight: 1.4,
          color: 'text.primary',
          '&.Mui-focused, &.Mui-error': { color: 'text.primary' },
          '& .MuiFormLabel-asterisk': { color: 'error.main', fontWeight: 700 },

        }}
      >
        {label}
      </FormLabel>
      {children}
      {error && (
        <FormHelperText sx={{ margin: '4px 0px' }}>{error}</FormHelperText>
      )}
      {!error && helper && (
        <FormHelperText sx={{ color: helperColor, margin: '4px 0px' }}>{helper}</FormHelperText>
      )}
    </FormControl>
  );
}